export default __webpack_public_path__ + "static/14-5c7a8e0af0607d9519c4413ece674c82.jpg";